import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useDashboard } from '../context/DashboardProvider';
import dayjs from 'dayjs';
import { useTheme } from '@mui/material/styles';

const DateSelector = () => {
  const { startDate, setStartDate, endDate, setEndDate, frequency, setFrequency } = useDashboard();
  const theme = useTheme();

  useEffect(() => {
    if (!startDate || !endDate) return;

    const diffDays = dayjs(endDate).diff(dayjs(startDate), 'day');

    let newFrequency = frequency; // Keep current frequency unless it needs adjustment

    if (diffDays > 1825) {
      newFrequency = 'yearly';
    } else if (diffDays > 365) {
      newFrequency = 'monthly';
    } else if (diffDays > 89) {
      newFrequency = 'weekly';
    } else {
      newFrequency = 'daily';
    }

    if (newFrequency !== frequency) {
      setFrequency(newFrequency); // Auto-switch only when the date range changes
    }
  }, [startDate, endDate]); // Runs only when the date range is updated

  return (
    <Box>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ marginBottom: '10px', fontSize: theme.typography.datePicker }}
      >
        Select Date Range
      </Typography>
      <Box display="flex" alignItems="center" gap={2}>
        <DatePicker
          label="Start Date"
          value={startDate}
          onChange={(newValue) => setStartDate(newValue)}
        />
        <DatePicker
          label="End Date"
          value={endDate}
          onChange={(newValue) => setEndDate(newValue)}
        />
      </Box>
    </Box>
  );
};

export default DateSelector;
